<template>
  <v-select
    v-model="valueOpcaoSelecionadaIdLocale"
    dense
    outlined
    no-data-text="Nenhum item registrado"
    item-text="nome"
    item-value="id"
    hide-details
    :label="label"
    :filled="filled"
    :disabled="disabled"
    :readonly="readonly"
    :items="opcoes"
    :rules="[isRequired]"
    @change="$emit('input-changed', { value: $event })"
  >
    <template
      v-if="mostrarIcones"
      v-slot:prepend
    >
      <icons
        :is-configurar-celula-dialog-open="isConfigurarCelulaDialogOpen"
        :is-deletar-componente-dialog-open="isDeletarComponenteDialogOpen"
        @update:is-configurar-celula-dialog-open="v => $emit('update:is-configurar-celula-dialog-open', v)"
        @update:is-deletar-componente-dialog-open="v => $emit('update:is-deletar-componente-dialog-open', v)"
      />
    </template>
  </v-select>
</template>

<script>
import { computed, ref, watchEffect } from '@vue/composition-api'
import { select } from '@core/utils/validation'
import Icons from './Icons.vue'
import ComponenteBase from './ComponenteBase.vue'
import selectableComponentMixin from '@/mixins/selectableComponentMixin'

export default {
  components: {
    Icons,
  },

  extends: ComponenteBase,

  mixins: [selectableComponentMixin],

  setup(props) {
    const isRequired = computed(() => (props.obrigatorio && !props.readonly ? select : true))

    const valueOpcaoSelecionadaIdLocale = ref('')
    watchEffect(() => { valueOpcaoSelecionadaIdLocale.value = props.valueOpcaoSelecionadaId })

    return {
      isRequired,
      valueOpcaoSelecionadaIdLocale,
    }
  },
}
</script>
